var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiances(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83333 12C11.7789 12 14.1667 9.61223 14.1667 6.66671C14.1667 3.72119 11.7789 1.33337 8.83333 1.33337C5.88781 1.33337 3.5 3.72119 3.5 6.66671C3.5 9.61223 5.88781 12 8.83333 12Z",
    stroke: "#2D2D2D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6043 7.33337C1.11674 8.07841 0.833252 8.96907 0.833252 9.92593C0.833252 12.5442 2.95577 14.6667 5.57403 14.6667C6.53089 14.6667 7.42155 14.3832 8.16659 13.8957",
    stroke: "#2D2D2D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4961 8.67912C11.6899 8.31305 11.5503 7.85917 11.1842 7.66535C10.8181 7.47153 10.3642 7.61116 10.1704 7.97723L11.4961 8.67912ZM10.1704 5.3561C10.3642 5.72217 10.8181 5.86181 11.1842 5.66799C11.5503 5.47416 11.6899 5.02028 11.4961 4.65422L10.1704 5.3561ZM6.83325 5.91667C6.41904 5.91667 6.08325 6.25245 6.08325 6.66667C6.08325 7.08088 6.41904 7.41667 6.83325 7.41667V5.91667ZM9.44864 7.41667C9.86285 7.41667 10.1986 7.08088 10.1986 6.66667C10.1986 6.25245 9.86285 5.91667 9.44864 5.91667V7.41667ZM8.19864 7.25926V6.07407H6.69864V7.25926H8.19864ZM9.27112 8.58333C8.76699 8.58333 8.19864 8.08459 8.19864 7.25926H6.69864C6.69864 8.72489 7.76219 10.0833 9.27112 10.0833V8.58333ZM9.27112 3.25C7.76219 3.25 6.69864 4.60844 6.69864 6.07407H8.19864C8.19864 5.24875 8.76699 4.75 9.27112 4.75V3.25ZM10.1704 7.97723C9.95923 8.37611 9.6117 8.58333 9.27112 8.58333V10.0833C10.2564 10.0833 11.0695 9.48488 11.4961 8.67912L10.1704 7.97723ZM9.27112 4.75C9.6117 4.75 9.95923 4.95722 10.1704 5.3561L11.4961 4.65422C11.0695 3.84846 10.2564 3.25 9.27112 3.25V4.75ZM6.83325 7.41667H9.44864V5.91667H6.83325V7.41667Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiances);
export default __webpack_public_path__ + "static/media/fiances.881054ebd24361d6640086e1f3702086.svg";
export { ForwardRef as ReactComponent };